"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("b", null, "marso", -1);
const _hoisted_2 = { class: "app-container" };
const _hoisted_3 = { class: "verification-title" };
const _hoisted_4 = { class: "verification-text" };
const _hoisted_5 = { class: "verification-under-text-margins" };
const Banner_vue_1 = __importDefault(require("../../../components/frontend/Banner.vue"));
const CustomButton_vue_1 = __importDefault(require("../../../components/frontend/CustomButton.vue"));
const Form_1 = require("../../../components/Form");
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const appLoginStore_1 = require("../../../stores/appLogin/appLoginStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Verification',
    setup(__props) {
        const authCode = (0, vue_3.ref)("");
        const authCodeError = (0, vue_3.ref)("");
        //const valid: Ref<boolean> = ref(true);
        const router = (0, vue_router_1.useRouter)();
        //router.push("/admin"); // átírányít folyamatosan az admin loginra ha ide érkezne be van valaki
        const appLoginStore = (0, appLoginStore_1.useAppLoginStore)();
        const onAuthCodeInput = (e) => {
            authCode.value = e.target.value;
        };
        function validateAuthCode() {
            appLoginStore.appLogin(authCode.value, router);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(Banner_vue_1.default, { "background-image": "frontend/home_banner.png" }, {
                    bannerText: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" CLICK'N'FIT ")
                    ]),
                    bottomText: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" powered by "),
                        _hoisted_1
                    ]),
                    _: 1
                }),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(_ctx.$trans("welcome_text", "Welcome back!", "frontend_verification")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.$trans("send_email_text", "We have sent a code to the email address you provided, which you can now you can now simply log in.", "frontend_verification")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: authCode.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((authCode).value = $event)),
                            "invalid-message": authCodeError.value,
                            label: _ctx.$trans('auth_code', 'Authentication code', 'frontend_verification'),
                            name: "authCode",
                            "show-validity": true,
                            onInput: onAuthCodeInput
                        }, null, 8, ["modelValue", "invalid-message", "label"]),
                        (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                            type: "red",
                            class: "button-top-margin",
                            onPressed: _cache[1] || (_cache[1] = ($event) => (validateAuthCode()))
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("next", "Next", "frontend_verification")), 1)
                            ]),
                            _: 1
                        })
                    ])
                ])
            ], 64));
        };
    }
});
